import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { formsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Forms($search: String, $page: Int) {
    forms(search: $search, page: $page, sort: { field: NAME, type: ASC }) {
      id
      name
      checklistId
    }
  }
`

const useFormsLoader = () => {
  const query = usePromiseQuery(QUERY, { client: formsClient })

  return (search, page = 1) => {
    return query({ search, page })?.then(pathOr([], ['data', 'forms']))
  }
}

const FormSelect = ({ onChange, value, ...props }) => {
  const getOptions = useFormsLoader()

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      {...props}
    />
  )
}

export default FormSelect
